
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/topics/[topic]",
      function () {
        return require("private-next-pages/blog/topics/[topic].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/topics/[topic]"])
      });
    }
  